/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IAppConfigApi {
    getAppSettings(cancelToken?: CancelToken): AxiosPromise<AppSettings>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_AppConfigApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_AppConfigApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class AppConfigApi implements IAppConfigApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_AppConfigApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_AppConfigApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getAppSettings(cancelToken?: CancelToken): AxiosPromise<AppSettings> {
        let url_ = "/marketing/api/bff/AppConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<AppSettings>(options_);
    }
}

export interface AppSettings {
    environmentTag: string;
    featureFlagClientId: string;
}
